import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AmdNavbarItemComponent } from './navbar-item.component';
var AmdNavbarItemModule = /** @class */ (function () {
    function AmdNavbarItemModule() {
    }
    AmdNavbarItemModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [AmdNavbarItemComponent],
                    exports: [AmdNavbarItemComponent]
                },] },
    ];
    /**
     * @nocollapse
     */
    AmdNavbarItemModule.ctorParameters = function () { return []; };
    return AmdNavbarItemModule;
}());
export { AmdNavbarItemModule };
function AmdNavbarItemModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdNavbarItemModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdNavbarItemModule.ctorParameters;
}
//# sourceMappingURL=navbar-item.module.js.map
//# sourceMappingURL=navbar-item.module.js.map
